import { render, staticRenderFns } from "./PlaylistExercises.vue?vue&type=template&id=1ed4050b"
import script from "./PlaylistExercises.vue?vue&type=script&lang=js"
export * from "./PlaylistExercises.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports